export enum BackendTools {
  ExecuteQueryV1 = 'execute_query_v1_0_0',
  LdsGeocodeV1 = 'lds_geocode_v1_0_0',
  AsyncWorkflowJobGetResultsV1 = 'async_workflow_job_get_results_v1_0_0'
}
